import { AlertSeverity } from 'app/alerts/models/Alert';
import { Site } from 'app/site-detail/models/Site';

export const SITES_START_OFFSET = 0;

export const SITE_AVAILABILITY = {
    CONNECTED: 'CONNECTED',
    DISCONNECTED: 'DISCONNECTED',
} as const;

export type SiteAvailability = (typeof SITE_AVAILABILITY)[keyof typeof SITE_AVAILABILITY] | null;

export interface SiteListSite extends Site {
    deviceCount: number | null;
    availability: SiteAvailability;
}

export interface SitesRequest {
    readonly offset: number;
    readonly limit: number;
    readonly keyword: string;
    readonly searchToken: string;
}

export interface SitesPage {
    readonly totalCount: number;
    readonly results: readonly SiteListSite[];
}

export interface SiteListRow {
    readonly site: SiteListSite;
    readonly clientName: string;
    readonly activationDate: string;
    readonly alertsSeverity: AlertSeverity | null;
    readonly isToolbox: boolean;
    readonly unavailableReasonKey?: string;
}
